export function SiteFooter() {
  return (
    <footer className="mt-auto">
      <div className="mx-auto flex max-w-2xl flex-col items-center gap-1 px-4 py-5 text-center text-xs leading-relaxed text-muted-foreground">
        <p>Made with ❤️ in Saint Petersburg Florida</p>
        <p>Built & hosted by RollemTech</p>
      </div>
    </footer>
  );
}
